import { useState } from "react";
import { useDispatch } from "react-redux";

import Swal from "sweetalert2";
import { updateBeneficiaryRequest } from "../../store/actions/adminActions";

export function useBeneficiaryWithdrawalActions() {
    const dispatch = useDispatch();

    const [selectedRequest, setSelectedRequest] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showCommentsModal, setShowCommentsModal] = useState(false);
    const [processingAction, setProcessingAction] = useState(false);
    const [comments, setComments] = useState("");

    const handleViewDetails = (request) => {
        setSelectedRequest(request);
        setShowDetailsModal(true);
    };

    const handleUpdateStatus = (status) => {
        if (status === "rejected" && !comments.trim()) {
            setShowCommentsModal(true);
            return;
        }

        updateRequestStatus(status);
    };

    const updateRequestStatus = (status) => {
        setProcessingAction(true);

        const updateData = {
            status,
            comments: comments || undefined
        };

        const requestId = selectedRequest._id;

        dispatch(updateBeneficiaryRequest({ requestId, updateData }))
            .then(() => {
                Swal.fire({
                    icon: "success",
                    title: `Request ${status.charAt(0).toUpperCase() + status.slice(1)}`,
                    text: `The beneficiary withdrawal request has been ${status}.`
                });
                setShowDetailsModal(false);
                setShowCommentsModal(false);
                setComments("");
            })
            .catch(error => {
                Swal.fire({
                    icon: "error",
                    title: "Update Failed",
                    text: error.message || "Failed to update beneficiary withdrawal request"
                });
            })
            .finally(() => {
                setProcessingAction(false);
            });
    };

    const closeModals = () => {
        setShowDetailsModal(false);
        setShowCommentsModal(false);
        setComments("");
    };

    return {
        selectedRequest,
        showDetailsModal,
        showCommentsModal,
        processingAction,
        comments,
        setSelectedRequest,
        setShowDetailsModal,
        setShowCommentsModal,
        setComments,
        handleViewDetails,
        handleUpdateStatus,
        closeModals
    };
}